import { useContext, useState, Fragment } from "react";

import { AuthContext } from "../../../contexts/AuthContext";
import Button from "../../../components/Button";
import { MinusCircleIcon } from "@heroicons/react/20/solid";

import { Menu, Transition } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/20/solid";

import { classNames } from "../../../utils/functions";
import { POST } from "../../../api/requests";
import { useDialog } from "../../../contexts/DialogContext";

import { toast } from "react-toastify";
const ALLOWED_ROLES = [
  { name: "Member", role: "member" },
  { name: "Admin", role: "admin" },
];

const DEFAULT_ROLE = { role: "member", name: "Member" };

export default function InviteUsers({ group_id }) {
  const [invites, setInvites] = useState([{ email: "", role: DEFAULT_ROLE }]);
  const { hideDialog } = useDialog();
  const addInvite = () => {
    setInvites([...invites, { email: "", role: DEFAULT_ROLE }]);
  };

  const handleInviteChange = (index, event) => {
    const values = [...invites];
    values[index][event.target.name] = event.target.value;
    setInvites(values);
  };
  const sendInviteToEmail = async () => {
    setInvites((prevInvites) => prevInvites.filter((i) => i.email?.length > 0));
    for (let invite of invites) {
      let emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailPattern.test(invite.email)) {
        alert("Invalid email address");
        return;
      }

      // Extract raw role from the nested role object
      invite.role = invite.role.role;
    }

    await POST(`/organizations/${group_id}/invite`, { invites: invites });

    toast(`Invite${invites.length > 1 && "s"} sent`);

    // Close dialog once done
    hideDialog();
  };

  return (
    <div className="w-full">
      <h1 className="font-semibold text-gray-700 mb-6">
        Invite people to your team
      </h1>
      {invites?.map((invite, index) => (
        <div key={index}>
          <div className="flex items-center space-x-2 mb-2">
            <input
              type="email"
              name="email"
              value={invite.email}
              className="border border-gray-300 w-full text-sm shadow-sm bg-white rounded-md"
              onChange={(event) => handleInviteChange(index, event)}
              placeholder="Email"
            />
            <Menu as="div" className="relative inline-block text-left">
              <div>
                <Menu.Button
                  className={`inline-flex w-full justify-center gap-x-1.5 rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 
                     
                    `}
                >
                  {invite.role.name}

                  <ChevronDownIcon
                    className="-mr-1 h-5 w-5 text-gray-400"
                    aria-hidden="true"
                  />
                </Menu.Button>
              </div>

              <Transition
                as={Fragment}
                enter="transition ease-out duration-100"
                enterFrom="transform opacity-0 scale-95"
                enterTo="transform opacity-100 scale-100"
                leave="transition ease-in duration-75"
                leaveFrom="transform opacity-100 scale-100"
                leaveTo="transform opacity-0 scale-95"
              >
                <Menu.Items className="absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                  <div className="py-1">
                    {ALLOWED_ROLES.map((role) => (
                      <Menu.Item>
                        {({ active }) => (
                          <a
                            href="#"
                            className={classNames(
                              active
                                ? "bg-gray-100 text-gray-900"
                                : "text-gray-700",
                              "block px-4 py-2 text-sm"
                            )}
                            onClick={() => {
                              let newInvites = [...invites];
                              newInvites[index].role = role;
                              setInvites(newInvites);
                            }}
                          >
                            {role.name}
                          </a>
                        )}
                      </Menu.Item>
                    ))}
                  </div>
                </Menu.Items>
              </Transition>
            </Menu>
            {
              // Ensure user can't delete all invite inputs
              (invites.length > 1 || index > 0) && (
                <button
                  onClick={() => {
                    if (invites.length > 1) {
                      setInvites(invites.filter((_, i) => i !== index));
                    }
                  }}
                >
                  <MinusCircleIcon className="w-5 text-red-600" />
                </button>
              )
            }
          </div>
        </div>
      ))}
      <div className="flex items-center mt-2 space-x-2 text-gray-600">
        <button
          className="bg-gray-200 py-2 text-xs rounded-lg px-3 font-md"
          onClick={addInvite}
        >
          Add another
        </button>
        {
          //Only show send button when there is at least one email
          invites.map((i) => i.email).filter((e) => e.length > 0).length >
            0 && (
            <div>
              <Button
                style={"filled"}
                onClick={() => sendInviteToEmail(invites)}
                label={"Send invites"}
              />
            </div>
          )
        }
      </div>
    </div>
  );
}
